import React from "react";
import { Link } from "react-router-dom";
import { projects } from "../../data";

const formatDateRange = (start, end) => {
  if (start === end) return start;
  return `${start} – ${end}`;
};

const isInternal = (link) => link && link.startsWith("/");

export default function Projects() {
  return (
    <section id="projects">
      <div className="container">
        <p className="section-label">projects</p>
        {projects.map((project) => (
          <div key={project.title} className="project-row">
            <div className="item-date">{formatDateRange(project.startDate, project.endDate)}</div>
            <div>
              {project.link ? (
                isInternal(project.link) ? (
                  <Link to={project.link} className="project-link project-link-internal">
                    {project.title}
                  </Link>
                ) : (
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                    {project.title}
                  </a>
                )
              ) : (
                <span className="project-title-plain">{project.title}</span>
              )}
              <p className="item-desc">{project.description}</p>
              <div className="tag-list">
                {project.tags.map((tag) => (
                  <span className="tag" key={tag}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
